export const getShortOrderNumber = woNumber => woNumber?.replace(/WO-/, '');

export const filterOrdersForApproval = orders =>
  (orders || []).reduce((acc, order) => {
    const obj = { ...order };
    const rOrdersToApprove = (order.relatedOrders || []).reduce(
      (accumulator, relatedOrder) => {
        if (relatedOrder.requiresApproval) accumulator.push(relatedOrder);
        return accumulator;
      },
      []
    );
    obj.relatedOrders = rOrdersToApprove;
    acc.push(obj);
    return acc;
  }, []);
